import { Injector } from "@angular/core";

export class AppInjector {
    static instance: Injector;
}